import { useInputCompositionContext } from "../../../../../hooks/useInputCompositionContext/useInputCompositionContext";

import React, { forwardRef, useState } from "react";
import DatePicker from "react-datepicker";

import ru from "date-fns/locale/ru";
import { registerLocale } from "react-datepicker";

registerLocale("ru", ru);

const CustomInput = forwardRef(({ value, onClick }, ref) => (
    <div className="input-composition-default-datepicker__datepicker_select" onClick={onClick} ref={ref}>
        {value}
    </div>
));

const CustomDisabledInput = forwardRef(({ value, onClick }, ref) => (
    <div className="input-composition-default-datepicker__datepicker_select">
        {/*{value}*/}
    </div>
));

const ICDatepickerSelect = (
    {
        checkbox,
        changeHandler,
        minDate,
        maxDate,
        field,
        delegation,
    }
) => {

    const [stateModel, setStateModel, isError, setIsError] = useInputCompositionContext();

    const [checkboxState, setCheckboxState] = useState(true);

    const [startDate, setStartDate] = useState(null);

    function onChangeCheckboxHandler (event) {
        setCheckboxState(event.target.checked);
        setIsError(prev => {
            const temp = prev;
            console.log(temp, field);
            if (temp[field]) {
                delete temp[field];
            }
            console.log(temp);

            return temp;
        });
        if (!event.target.checked) {
            setStartDate(null);
            setIsError(prev => {
                const temp = prev;
                console.log(temp, field);
                if (temp[field]) {
                    delete temp[field];
                }
                console.log(temp);

                return temp;
            });
            setStateModel(prev => {
                console.log(field);
                const temp = prev;
                if (prev[field]) {

                    if (delegation) {
                        temp.rules = {
                            "delegatePid": ["notEmpty"],
                            "from": ["notEmpty", "earlierThan"],
                        };
                        delete temp.rules.comment;
                    } else {
                        temp.rules = {
                            "substitutePid": ["notEmpty"],
                            "from": ["notEmpty", "earlierThan"],
                            "comment": ["notEmpty"],
                        };
                    }
                    delete temp[field];
                    return temp;
                } else {
                    if (delegation) {
                        temp.rules = {
                            "delegatePid": ["notEmpty"],
                            "from": ["notEmpty", "earlierThan"],
                        };
                        delete temp.rules.comment;
                    } else {
                        temp.rules = {
                            "substitutePid": ["notEmpty"],
                            "from": ["notEmpty", "earlierThan"],
                            "comment": ["notEmpty"],
                        };
                    }
                    return temp;
                }
                console.log(prev);

            });
        } else {
            setIsError(prev => {
                const temp = prev;
                console.log(temp, field);
                if (temp[field]) {
                    delete temp[field];
                }
                console.log(temp);

                return temp;
            });
            setStateModel(prev => {
                console.log(prev);
                const temp = prev;
                if(delegation) {
                    temp.rules = {
                        "delegatePid": ["notEmpty"],
                        "from": ["notEmpty", "earlierThan"],
                        "to": ["notEmpty"],
                    };
                } else {
                    temp.rules = {
                        "substitutePid": ["notEmpty"],
                        "from": ["notEmpty", "earlierThan"],
                        "to": ["notEmpty"],
                    };
                }
                return temp;
                console.log(prev);

            });
        }
    }

    // console.log(" STATE: ", field, ": ", stateModel["to"]);
    // console.log(" MAX DATE: ", field, ": ", maxDate);

    // console.log(" MIN DATE: ", field, ": ", minDate);

    return (
        <div style={
            isError &&
            isError[field]
                ? {display: "flex", gap: "10px", borderBottom: "1px solid red", maxWidth: "290px", position: "relative"}
                : {display: "flex", gap: "10px", borderBottom: "1px solid #EEEEEE", maxWidth: "290px", position: "relative"}}>
            <DatePicker
                minDate={minDate ? new Date(minDate) : null}
                maxDate={maxDate && stateModel["to"] ? new Date(maxDate) : null}
                selected={startDate}
                locale={"ru"}
                dateFormat="dd.MM.yyyy"
                popperPlacement="bottom-start"
                popperModifiers={[
                    {
                        name: "preventOverflow",
                        enabled: false,
                    },
                    {
                        name: "hide",
                        enabled: false,
                    },
                    {
                        name: "flip",
                        enabled: false, // отключает автоматическое переворачивание
                    },
                ]}
                onChange={(date) => {
                    changeHandler(false, false, date);
                    setStartDate(date);
                }}
                customInput={
                    checkbox && !checkboxState
                        ? <CustomDisabledInput />
                        : <CustomInput/>
                }
            />
            {
                checkbox
                    ? <input
                        style={
                            {
                                width: "20px",
                                display: "block",
                                position: "absolute",
                                top: "16px",
                                left: "270px",
                            }
                        }
                        type="checkbox"
                        checked={checkboxState}
                        onChange={onChangeCheckboxHandler}
                    />
                    : null
            }
        </div>
    );
};

export default ICDatepickerSelect;
